import styled from 'styled-components';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import Typography from '../../atoms/Typography';

export const Preview = styled.img`
background-color: ${({ theme }) => theme.lightGray};
border: 1px solid ${({ theme }) => theme.grey[300]};
/* transition: all .2s ease-in-out; */
/* background-image: url(${({ image }) => image};); */
/* background-size: cover; */
object-fit: cover;
/* border-radius: 5px; */
transition: 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
border-radius: inherit;
width: 100%;
${({ onClick, theme }) =>
  onClick &&
  `
  &:hover {
    cursor: pointer;
    border-color: ${theme.grey[700]};
    transition: 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    // border-color: red;

  }
`}
/* margin: 0.5rem; */

`;

export const IconContainer = styled.div`
  position: absolute;
  border-radius: 50%;
  ${({ preview }) =>
    preview === 'circle'
      ? `
      left: 1.3rem;
    top: 0.9rem;
        `
      : `
      left: -0.7rem;
    top: -0.6rem;
        `};

  z-index: 1;
  color: ${({ theme }) => theme.grey[300]};

  svg {
    background-color: ${({ theme }) => theme.white};
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.grey[300]};
    padding: 2px;
    width: 1.5rem;
    height: 1.5rem;
  }

  ${({ onClick, theme }) =>
    onClick &&
    `
    &:hover {
    cursor: pointer;
    border-color: ${theme.grey[400]};
    }
  `}
`;

export const UploaderContainer = styled.div`
  display: flex;
  margin: 0.5rem;
  margin-top: 1rem;
  position: relative;
  border-radius: 50%;
  ${({ preview }) => {
    if (preview === 'circle') {
      return `
    width: 12rem;
    height: 12rem;
    border-radius: 50%;
        `;
    }
    if (preview === 'cover') {
      return `
    width: 100%;
    height: 13rem;
`;
    }
    return `
    width: 10rem;
    height: 10rem;
        `;
  }}
`;

export const Label = styled(Typography)`
  && {
    margin-left: 0.5rem;
  }
`;

export const Container = styled.div`
  margin-top: 1rem;
  margin-bottom: 2rem;
   
`;

export const PreviewContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Uploader = styled.div`
  background-color: ${({ theme }) => theme.lightGray};
  border: 1px solid ${({ theme }) => theme.grey[300]};
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  text-align: center;
  font-size: 0.8rem;
  
  &:hover {
    cursor: pointer;
    border-color: ${({ theme }) => theme.grey[700]};
    transition: 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
`;

export const UploadIcon = styled(AddAPhotoIcon)`
  && {
    font-size: 50px;
    color: ${({ theme }) => theme.grey[700]};
    margin-bottom: 0.3rem;
  }
 
`;

export const ErrorList = styled.ul`
  color:  ${({ theme }) => theme.red[400]};
  margin-top: 0;
`;

